import PostLikesModal from './PostLikesModal'

export default PostLikesModal
